import { map, intersection } from 'lodash-es';
import { IDirective } from 'angular';
import { userService } from '../user.service';

const directiveName = 'showForRoles';

export function showForRolesDirective(): IDirective {
  return {
    link(scope, element, attrs) {
      const rolesAllowed = scope.$eval(attrs[directiveName].toLowerCase());
      const userRoles = map(userService.roles, (role) => role.toLowerCase());

      const rolesThatMatch = intersection(rolesAllowed, userRoles);
      if (rolesThatMatch.length === 0) {
        element.remove();
      }
    },
  };
}

export const ngShowForRolesDirective = {
  [directiveName]: showForRolesDirective,
};
